/**
 * Page wrapper for the New-monitor wizard route (/v4/monitor/new).
 *
 * Admin-gated by the route configuration (mounted under <AdminRoute>);
 * this component just owns the navigate-on-exit behavior.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';

import MonitorSetupWizard from './wizard/MonitorSetupWizard';

const MonitorSetupPage: React.FC = () => {
  const navigate = useNavigate();
  return <MonitorSetupWizard onExit={() => navigate('/v4/records')} />;
};

export default MonitorSetupPage;
